import React from "react";
import { Platform } from "react-native";
import { ActionsScreenContext } from "./common";
import { FlatListSearchableSkeleton } from "../../../../components/FlatListSearchableSkeleton";
import { StackScreenProps } from "@react-navigation/stack";
import { AiInsightsActionsRootScreenParamList } from "../../../../types";
import { useHasTransitionEnded } from "../../../../utilities/use-after-interactions";
import {
  Card,
  FlatActionList,
  FlatActionListItem,
  Page,
  Stack,
  useFlashMessages,
} from "@towersystems/roam-common-native";
import * as Clipboard from "expo-clipboard";

export interface AiInsightsActionsListScreenProps
  extends StackScreenProps<
    AiInsightsActionsRootScreenParamList,
    "AiInsightsActionsListScreen"
  > {}

import * as Print from "expo-print";
import { usePrint } from "../../../../utilities/print";

export const AiInsightsActionsListScreen = ({
  navigation,
}: AiInsightsActionsListScreenProps) => {
  const [performingAction, setPerformingAction] = React.useState(false);
  const context = React.useContext(ActionsScreenContext);
  const transitionEnded = useHasTransitionEnded(navigation);
  const flashMessagesContext = useFlashMessages();
  const { print } = usePrint();

  const handleCopyToClipboard = async () => {
    if (!context || !context.result || !context.result.result) {
      return;
    }
    await Clipboard.setStringAsync(context.result.result);
    flashMessagesContext.showMessage({
      severity: "success",
      message: "AI summary copied to clipboard",
    });
  };

  const handleOnPrint = async () => {
    await print(context?.result?.result || "No AI summary available to print");
  };

  if (!context || context.result === undefined || !transitionEnded) {
    return <FlatListSearchableSkeleton searchbar={false} />;
  }

  const actions: FlatActionListItem[] = [
    {
      key: "email-result",
      title: "Email AI Summary",
      subTitle: "Send the AI generated summary to your email",
      disabled: performingAction,
      onPress: async () => {
        navigation.navigate("AiInsightsActionsEnterEmailScreen");
      },
    },
    {
      key: "print-result",
      title: "Print AI Summary",
      subTitle: "Print the AI generated summary",
      disabled: performingAction,
      onPress: async () => {
        setPerformingAction(true);
        await handleOnPrint();
        setPerformingAction(false);
      },
    },
    {
      key: "copy-clipboard",
      title: "Copy to Clipboard",
      subTitle: "Copy the AI generated summary to clipboard",
      disabled: performingAction,
      onPress: async () => {
        setPerformingAction(true);
        await handleCopyToClipboard();
        setPerformingAction(false);
      },
    },
  ];

  return (
    <Page title="Actions" secondaryTitle="Select an action to perform">
      <Stack vertical>
        <Card>
          <FlatActionList items={actions} />
        </Card>
      </Stack>
    </Page>
  );
};
